import { render, staticRenderFns } from "./22.vue?vue&type=template&id=ae5988ea&scoped=true&"
var script = {}
import style0 from "./22.vue?vue&type=style&index=0&id=ae5988ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5988ea",
  null
  
)

export default component.exports